// Dynamic pricing initialization
console.log('[DynamicPricingInit] Starting initialization');

// Get values from theme settings
window.dynamicDiscountPercentage = window.auroraTheme?.themeSettings?.automatic_discount_percentage || 0;
window.dynamicDiscountCode = window.auroraTheme?.themeSettings?.automatic_discount_code || '';
window.dynamicDiscountEnabled = window.auroraTheme?.themeSettings?.enable_automatic_discount || false;

console.log('[DynamicPricingInit] Set global variables:', {
  dynamicDiscountPercentage: window.dynamicDiscountPercentage,
  dynamicDiscountEnabled: window.dynamicDiscountEnabled,
  themeSettings: window.auroraTheme?.themeSettings
});

// Only initialize if dynamic pricing is enabled
if (!window.dynamicDiscountEnabled) {
  console.log('[DynamicPricingInit] Dynamic pricing is disabled, skipping initialization');
} else {
  document.addEventListener('DOMContentLoaded', function() {
    console.log('[DynamicPricingInit] DOM loaded, initializing dynamic pricing');

    // Verify the dynamic-pricing.js script is loaded
    if (typeof DynamicPricing === 'undefined') {
      console.error('[DynamicPricingInit] Error: DynamicPricing class not found. Make sure dynamic-pricing.js is loaded before this script.');
      return;
    }

    console.log('[DynamicPricingInit] DynamicPricing class found, proceeding with initialization');
    new DynamicPricing();
  });
}
